export const PREMIUM_REVIEWS = 'premium_reviews';
export const UNSUPPORTED = 'unsupported';
export const NOW = 'now';

export type DowngradeFeatureMessage = {
  name: string;
  message: string;
};

export const DOWNGRADE_FEATURES_MESSAGES: DowngradeFeatureMessage[] = [
  {
    name: 'profit_rhino',
    message: `By proceeding with removing the Profit Rhino add-on, please note that this will remove all content including the Profit Rhino services and materials. Any price book items you have manually created or imported will remain.`,
  },
];
